<template>
  <ItemsQuestion
    v-if="parkOffersIncubation"
    ref="child"
    v-on:answerUpdated="onAnswerUpdated"
    :question="question"
    :answer="answer"
    :isDisabled="isDisabled"
  ></ItemsQuestion>
</template>

<script>
  import ParkPrograms from '@/services/park_programs'
  import ItemsQuestion from './ItemsQuestion'

  export default {
    name: 'IncubationProgramItemsQuestion',
    components: { ItemsQuestion },
    props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
    methods: {
      isValid () {
        if (!this.parkOffersIncubation) {
          return true
        }
        return this.$refs.child.isValid()
      },
      onAnswerUpdated (answer) {
        this.$emit('answerUpdated', answer)
      }
    },
    computed: {
      parkOffersIncubation () {
        return ParkPrograms.has(ParkPrograms.INCUBATION, this.quizAnswers)
      }
    },
    watch: {
      parkOffersIncubation: {
        immediate: true,
        handler () {
          if (!this.parkOffersIncubation) {
            this.$emit('answerUpdated', {...this.answer, value: null})
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// IncubationProgramItemsQuestion.vue?1e4a36c2